export default "__VITE_ASSET__BSUDkjb3__"